import React from 'react'

export const Button = ({to, numberItems,click, att,name, iconLeft, iconRight, iconColor}) => {
  return (
    <button onClick={click} className={`${att} text-[16px] h-10 flex items-center justify-center rounded-lg space-x-2 text-center py-3 px-4 dark:bg-transparent dark:text-white dark:border-white `}>
     {<div className={`${iconColor}`}>{iconLeft}</div> &&
      <div className={`${iconColor}`}>{iconLeft}</div>
      }
      {name ? 
      <p className=''>{name}</p>
      : ''
      }
       {<div className={`${iconColor}`}>{iconRight}</div> &&
      <div className={`${iconColor}`}>{iconRight}</div>
      }
      {numberItems &&
      <div className='text-black bg-white p-3 rounded-full w-4 h-4 flex items-center justify-center '>{numberItems}</div>
      }
    </button>
  )
}
